import type { SelectOption } from '@kula-ai/components';

// Shown in place of the template name once the content no longer matches it.
export const CUSTOM_TEMPLATE_LABEL = 'Custom';

/**
 * Select props that relabel the *closed* picker to "Custom" once its content
 * has diverged from the selected template.
 *
 * `renderTriggerValue` is the only seam that works: kula overrides
 * react-select's `SingleValue` with a component that reads `data.label`, so a
 * `formatOptionLabel` never runs. Menu rows are untouched, and the select's
 * value keeps the real template id.
 *
 * Shared by the email composers and the scorecard step — how "diverged" is
 * decided differs per surface and stays with that surface.
 */
export function customTemplateSelectProps(isEdited: boolean) {
  return {
    renderTriggerValue: (selected: SelectOption | SelectOption[]) => {
      const option = Array.isArray(selected) ? selected[0] : selected;
      return isEdited ? CUSTOM_TEMPLATE_LABEL : option?.label;
    },
  };
}

/**
 * The same relabel for the legacy FormBuilder `select` / `kSelect` fields,
 * which expose `customFormatLabel(option, labelKey, item, context)` instead.
 * Only the closed trigger is rewritten, so menu rows keep their real names.
 */
export function customTemplateFormatLabel(isEdited: boolean) {
  return (
    option: Record<string, unknown>,
    labelKey: string,
    _item: unknown,
    context?: 'menu' | 'value'
  ) =>
    isEdited && context === 'value'
      ? CUSTOM_TEMPLATE_LABEL
      : (option?.[labelKey] as string);
}
